import { GetServerSidePropsContext } from 'next'

import Container from '@/components/Container/Container'
import Main from '@/components/Main/Main'
import SimpleHeader from '@/components/SimpleHeader/SimpleHeader'
import ArticleSearch from '@/components/Wordpress/ArticleSearch/ArticleSearch'
import ArticleTypePage from '@/components/Wordpress/ArticleTypePage/ArticleTypePage'
import { formatTag, getPosts } from '@/services/wordpress.service'
import { PostType } from '@/types/wordpress'
import { ARTICLES_CACHE_CONTROL } from '@/utils/constants'

export type Props = {
  enableAdhesion: boolean
  pageCount: number
  pageNum: number
  posts: PostType[]
  tag: string
}

const ArticlesTagSubPage = ({ enableAdhesion, pageCount, pageNum, posts, tag }: Props) => (
  <Main>
    <Container>
      <div className='mx-3'>
        <SimpleHeader className='d-flex gap-3 mb-3'>
          {formatTag(tag)}
          <ArticleSearch />
        </SimpleHeader>
        <ArticleTypePage pageCount={pageCount} pageNum={pageNum} path={`tag/${tag}`} posts={posts} />
      </div>
      {enableAdhesion && <div className='mvHomeAdhesion' />}
    </Container>
  </Main>
)

export const getServerSideProps = async ({ params, res }: GetServerSidePropsContext) => {
  let page = params?.page
  const tag = params!.tag as string

  if (page === '1') {
    return {
      redirect: {
        destination: `/articles/tag/${tag}`,
        permanent: true,
      },
    }
  } else if (page === undefined) {
    page = '1'
  }

  res.setHeader('Cache-Control', ARTICLES_CACHE_CONTROL)

  // Parse the page number and redirect to parsed integer if necessary
  const pageNum = parseInt(page as string, 10)
  if (page !== `${pageNum}`) {
    return {
      redirect: {
        destination: `/articles/tag/${tag}/${pageNum}`,
        permanent: true,
      },
    }
  }

  try {
    const { pageCount, posts } = await getPosts({ category: 4, page: pageNum, tag })
    return {
      props: {
        enableAdhesion: true,
        pageCount,
        pageNum,
        posts,
        tag,
      },
    }
  } catch (error) {
    console.error('Error fetching posts:', error)
    return { notFound: true }
  }
}

export default ArticlesTagSubPage
